var map = {
	"./img_partner1.png": 56615,
	"./img_partner2.png": 57139,
	"./img_partner3.png": 29502,
	"./img_partner4.png": 41715,
	"./img_partner5.png": 94836,
	"./img_partner6.png": 56851,
	"./img_partner7.png": 60563,
	"./img_partner8.png": 14273,
	"./img_partner9.png": 41054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92605;